export default __webpack_public_path__ + "images/47.27b6cba.png";